export default (host: string) => {
  const index = host.indexOf('.');

  return [host.substring(0, index), host.substring(index)];
};
